module.exports = __webpack_public_path__ + "img/s2-0.a1512e0a.svg";